module.exports = __webpack_public_path__ + "img/nicholasanthony.04e565e6.png";